import { queryString } from '@shared/hooks/recoil-query';
import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import {
  GiftSupplySettlement,
  GiftSupplySettleBody,
  GiftSupplySettleResult,
  GiftSupplySettlementPatchBody,
} from './giftSupplySettlement.interface';

// GiftAgent 유저는 /gift-seller 포털 진입 후 giftBrandRole()이 LowerRole.Admin을 반환하므로
// 백엔드 prefix는 /admin을 사용한다. LowerRole.GiftAgent는 이 API에서 쓰이지 않는다.
export type GiftSupplySettlementRole = LowerRole.Admin | LowerRole.GiftBrandSeller;

// ===== 조회 =====

export const listGiftSupplySettlements = async (
  filter: Record<string, unknown> = {},
  populate: unknown[] = [],
  options: Record<string, unknown> = { sort: { year: -1, month: -1 } },
  role: GiftSupplySettlementRole = LowerRole.Admin,
): Promise<GiftSupplySettlement[]> => {
  const { data } = await api_.get<GiftSupplySettlement[]>(
    `/${role}/gift-supply-settlement?${queryString({ filter, populate, options })}`,
  );
  return data;
};

export const getGiftSupplySettlementById = async (
  id: string,
  populate: unknown[] = [],
  role: GiftSupplySettlementRole = LowerRole.Admin,
): Promise<GiftSupplySettlement> => {
  const { data } = await api_.get<GiftSupplySettlement>(
    `/${role}/gift-supply-settlement/${id}?${queryString({ populate })}`,
  );
  return data;
};

export const countGiftSupplySettlements = async (
  filter: Record<string, unknown> = {},
  role: GiftSupplySettlementRole = LowerRole.Admin,
): Promise<number> => {
  const { data } = await api_.get<number>(
    `/${role}/gift-supply-settlement/count?${queryString({ filter })}`,
  );
  return data;
};

// ===== 집행 (Admin 전용) =====

export const settleGiftSupply = async (
  body: GiftSupplySettleBody,
): Promise<GiftSupplySettleResult> => {
  const { data } = await api_.post<GiftSupplySettleResult>(
    `/${LowerRole.Admin}/gift-supply-settlement/settle`,
    body,
  );
  return data;
};

// ===== 수정 (Admin 전용) =====

export const patchGiftSupplySettlement = async (
  id: string,
  body: GiftSupplySettlementPatchBody,
): Promise<GiftSupplySettlement> => {
  const { data } = await api_.patch<GiftSupplySettlement>(
    `/${LowerRole.Admin}/gift-supply-settlement/${id}`,
    body,
  );
  return data;
};

// ===== 삭제 (Admin 전용) =====

export const deleteGiftSupplySettlement = async (id: string): Promise<void> => {
  await api_.delete(`/${LowerRole.Admin}/gift-supply-settlement/${id}`);
};
